import { MatDialog } from '@angular/material/dialog';
import { ReadApiService } from 'src/app/core/service/abstract/read-api.service';
import { User, UserTableVisualization } from 'src/app/data/model/user';
import { CrudApiService } from '../../core/service/abstract/rest-api.service';
import { UserTableVisualizationApiService } from '../api/services/user-table-visualization-api.service';
import { BaseListService } from './base-list.service';

export abstract class BaseEntityListService<
  T extends { id: number | null },
  K extends CrudApiService<T>,
  Q extends ReadApiService<UserTableVisualization>

> extends BaseListService<T, K, { id: number | null }, Q> {
  constructor(dialog: MatDialog, apiService: K, columnService: Q) {
    super(dialog, apiService, columnService);
  }
}

export type DialogParam = {
  id: number | null;
};
